import { css, unsafeCSS } from 'lit-element';
import {
  n75, negative300, info300, positive300, warning300, n670, white, gm100, n50, n300,
} from '@aab/sc-styles-colors';
import { mt_1 as mt1 } from '@aab/sc-styles-spacing';
import { border_box as borderBox } from '@aab/sc-styles-grid';
import { label } from '@aab/sc-styles-typography';

const commonStyles = css`
    ${unsafeCSS(mt1)}
    ${unsafeCSS(borderBox)}
    ${unsafeCSS(label)}
`;

const labelStyles = css`
  .input-label {
    display: inline-block;
    padding-right: 5px;
    padding-top: calc(.4375rem + 1px);
    padding-bottom: calc(.4375rem + 1px);
  }
`;

const inputStyles = css`
  input.form-control {
    background-clip: padding-box;
    background-color: ${unsafeCSS(white)};
    border: 1px solid;
    border-radius: .125rem;
    color: ${unsafeCSS(n670)};
    display: block;
    font-size: 1rem;
    font-weight: 400;
    height: calc(1.5em + .875rem + 2px);
    line-height: 1.5;
    margin: 0;
    padding: .4375rem .4375rem;
    transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    width: 100%;
  }

  input.width-20 {
    width: 20% !important;
  }
  input.width-25 {
    width: 25% !important;
  }
  input.width-30 {
    width: 30% !important;
  }
  input.width-35 {
    width: 35% !important;
  }
  input.width-40 {
    width: 40% !important;
  }
  input.width-45 {
    width: 45% !important;
  }
  input.width-50 {
    width: 50% !important;
  }
  input.width-55 {
    width: 55% !important;
  }
  input.width-60 {
    width: 60% !important;
  }
  input.width-65 {
    width: 65% !important;
  }
  input.width-70 {
    width: 70% !important;
  }
  input.width-75 {
    width: 75% !important;
  }
  input.width-80 {
    width: 80% !important;
  }
  input.width-85 {
    width: 85% !important;
  }
  input.width-90 {
    width: 90% !important;
  }
  input.width-95 {
    width: 95% !important;
  }

  input.form-control.default {
    border-color: ${unsafeCSS(n75)};
    -webkit-box-shadow: none;
  }
  input.form-control.default:focus {
    box-shadow: 0 0 0 .075rem ${unsafeCSS(n75)}
  }

  input.form-control.negative {
    border-color: ${unsafeCSS(negative300)} !important;
  }
  input.form-control.negative:focus{
    box-shadow: 0 0 0 .075rem ${unsafeCSS(negative300)} !important;
  }

  input.form-control.info {
    border-color: ${unsafeCSS(info300)} !important;
  }
  input.form-control.info:focus{
    box-shadow: 0 0 0 .075rem ${unsafeCSS(info300)} !important;
  }
  input.form-control.positive {
    border-color: ${unsafeCSS(positive300)} !important;
  }
  input.form-control.positive:focus{
    box-shadow: 0 0 0 .075rem ${unsafeCSS(positive300)} !important;
  }
  input.form-control.warning {
    border-color: ${unsafeCSS(warning300)} !important;
  }
  input.form-control.warning:focus{
    box-shadow: 0 0 0 .075rem ${unsafeCSS(warning300)} !important;
  }

  input.form-control::placeholder {
    color: ${unsafeCSS(gm100)};
  }
  input.form-control:disabled {
    background-color: ${unsafeCSS(n50)};
    border: 1px solid ${unsafeCSS(n75)};
  }
  input.form-control:disabled::placeholder {
    color: ${unsafeCSS(n300)};
  }
`;

export default {
  commonStyles,
  labelStyles,
  inputStyles,
};
